import React, { forwardRef } from "react";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Panel = React.memo(
  forwardRef(({ children, onClose }, ref) => {
    return (
      <div className="panel" ref={ref}>
        <FontAwesomeIcon
          icon="times"
          className="closePanel"
          onClick={onClose}
          size="lg"
        />
        {children}
      </div>
    );
  })
);

export default Panel;
